import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';
import { documentContract } from 'shared/domain/document/documentContract';
import { makeErrorPublisher, makeEventPublisher } from 'serviceWorker/broadcasts/publishers';

export const broadcastCreatedDocument = makeEventPublisher(documentContract, DomainMessagesTypes.createdEntity);

export const broadcastUpdatedDocument = makeEventPublisher(documentContract, DomainMessagesTypes.updatedEntity);

export const broadcastUploadedDocument = makeEventPublisher(documentContract, DomainMessagesTypes.uploadedEntity);

export const broadcastFailUploadedDocument = makeEventPublisher(documentContract, DomainMessagesTypes.failUploadedEntity);

export const broadcastRemovedDocument = makeEventPublisher(documentContract, DomainMessagesTypes.deletedEntity);

export const broadcastCreatedDrawing = makeEventPublisher(documentContract, DomainMessagesTypes.createdDrawing);

const broadcastDocumentError = makeErrorPublisher(
  documentContract
);

export const broadcastUploadedDocumentError = (
  error: unknown,
  messageId?: string | null
): void => {
  debugLog('broadcastUploadedDocumentError', error, messageId);
  broadcastDocumentError(DomainMessagesTypes.failUploadedEntity, error, {
    messageId: messageId || undefined,
  });
};
